module.exports = __webpack_public_path__ + "static/media/photo_2020-12-12_21-48-59.5166840f.jpg";